"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrayectoriaYCredenciales() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: photoRef,
    isVisible: photoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: storyRef,
    isVisible: storyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: signRef,
    isVisible: signVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraphs = ["MS Instituto Capilar nació de una convicción profunda: la salud capilar no es solo estética, es un reflejo de la salud integral y el bienestar personal. En un sector a menudo saturado de promesas rápidas y soluciones estandarizadas, entendimos que cada paciente requiere un enfoque clínico riguroso, donde la ciencia médica se encuentra con la atención personalizada.", "Fundamos nuestra clínica con un equipo multidisciplinar de especialistas en tricología, medicina estética y cirugía capilar avanzada. Compartimos una visión clara: ofrecer tratamientos basados en la evidencia, con una honestidad clínica inquebrantable y un compromiso absoluto con resultados naturales que devuelvan la confianza a nuestros pacientes.", "Nuestra metodología integra las tecnologías más precisas del mercado, desde el diagnóstico digital avanzado hasta técnicas de trasplante capilar de mínima invasión. No buscamos transformar radicalmente la imagen de nadie, sino restaurar la densidad y vitalidad que el tiempo o la genética han ido retirando, siempre respetando la armonía facial única de cada persona.", "Nuestro enfoque es deliberadamente exclusivo. Limitamos el número de intervenciones diarias para garantizar que cada paciente reciba la atención completa de la Dra. María del Carmen Soto y su equipo. No somos una cadena de volumen; somos un instituto de alta especialización donde cada detalle, desde la primera consulta hasta el seguimiento post-operatorio, está diseñado para la excelencia.", "Cada plan de tratamiento que diseñamos nace de una pregunta fundamental: ¿qué es lo mejor para la salud a largo plazo de este paciente? Esta premisa guía nuestra ética, nuestra formación continua y nuestra negativa a realizar procedimientos que no cumplan con nuestros estándares de seguridad y naturalidad.", "Tras años de trayectoria, MS Instituto Capilar se ha consolidado como un referente de confianza en Madrid. Medimos nuestro éxito no en el número de pacientes, sino en la satisfacción de quienes han recuperado su seguridad gracias a un trabajo bien hecho. Esa es nuestra labor. Ese ha sido siempre nuestro compromiso."];
  return <section data-section-id="3374" id="trayectoria-y-credenciales" className="text-foreground relative overflow-hidden bg-muted ![padding:100px_0px_80px_0px]">
      {}
      <div className="pointer-events-none absolute top-0 right-0 h-[700px] w-[700px] -translate-y-1/4 translate-x-1/4 opacity-40" style={{
      background: "radial-gradient(circle, hsla(38, 48%, 61%, 0.25) 0%, hsla(38, 48%, 61%, 0.08) 35%, transparent 70%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        {}
        <div ref={headlineRef} className="transition-all duration-1000 ease-out translate-y-0 opacity-100 !m-0">
          <div className="mb-10 flex justify-center md:mb-14">
            <span className="font-default text-xs tracking-[0.2em] text-[var(--chart-1)] uppercase !font-bold">EXCELENCIA Y COMPROMISO</span>
          </div>

          <h2 className="font-default text-center leading-[0.95] tracking-tight text-foreground !text-7xl"><span className="!text-7xl">Salud capilar con </span><span className="italic text-foreground/90" contenteditable="false" style={{}}><br />r<span className="!text-7xl" data-ast-id="f:/src/pages/DrSoto/sections/TrayectoriaYCredenciales.tsx|sig:cfsdiv" data-ast-start="4216" data-ast-end="4395">esultados naturales</span></span></h2>

          <div className="mt-10 flex justify-center md:mt-14">
            
          </div>
        </div>

        {}
        <div className="h-px w-full bg-border ![margin:0px_0px_60px_0px]" aria-hidden="true" />

        {}
        <div className="grid grid-cols-1 gap-12 !m-0 lg:grid-cols-12 lg:gap-16">
          {}
          <div ref={photoRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${photoVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative lg:sticky lg:top-24">
              <div className="relative overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_interior.png-wvc-sizes" alt="Interior elegante y clínico de MS Instituto Capilar" loading="lazy" decoding="async" className="w-full object-cover !opacity-[1] text-primary-foreground bg-ring !h-[1900px]" style={{
                filter: "saturate(0.9)"
              }} src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-3.png" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-4.png" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-4.png" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-4.png" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-5.png" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/Diseno-sin-titulo-6.png" />
                {}
                <div className="pointer-events-none absolute inset-0 opacity-20 mix-blend-overlay" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E\")"
              }} aria-hidden="true" />
                {}
                <div className="pointer-events-none absolute inset-0" style={{
                background: "linear-gradient(180deg, hsla(225, 54%, 24%, 0.15) 0%, hsla(225, 54%, 10%, 0.25) 100%)"
              }} aria-hidden="true" />
              </div>

              {}
              <div className="mt-5 flex items-start justify-between gap-4">
                <span className="font-default text-[10px] tracking-[0.18em] text-muted-foreground uppercase"></span>
                <span className="font-default text-[10px] tracking-[0.18em] text-[var(--chart-1)] uppercase">ms instituto capilar</span>
              </div>
            </div>
          </div>

          {}
          <div ref={storyRef} className={`lg:col-span-7 transition-all duration-1000 ease-out lg:pl-4 ${storyVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
          transitionDelay: "150ms"
        }}>
            {}
            <div className="mb-10 flex items-center gap-4">
              <span className="h-px w-10 bg-[var(--chart-1)]" aria-hidden="true" />
              <span className="font-default tracking-[0.2em] text-[var(--chart-1)] uppercase !text-xs !font-bold">NUESTRA ESENCIA</span>
            </div>

            {}
            <p className="mb-8 text-[18px] leading-[1.7] text-muted-foreground font-default">
              <span className="float-left mr-3 font-default text-[96px] leading-[0.85] text-[var(--chart-1)]" style={{
              marginTop: "0.05em"
            }}>
                M
              </span>
              {paragraphs[0]}
            </p>

            {}
            <p data-index={1} className="mb-10 text-[18px] leading-[1.7] text-muted-foreground font-default">
              {paragraphs[1]}
            </p>

            {}
            <blockquote className="my-14 border-l-2 border-[var(--chart-2)] pl-8">
              <p className="font-default text-[28px] leading-[1.25] italic text-foreground md:text-[36px]">
                "La medicina capilar es un arte que requiere precisión, paciencia y, sobre todo, honestidad."
              </p>
            </blockquote>

            {}
            <p data-index={2} className="mb-10 text-[18px] leading-[1.7] text-muted-foreground font-default">
              {paragraphs[2]}
            </p>

            {}
            <p data-index={3} className="mb-10 text-[18px] leading-[1.7] text-muted-foreground font-default">
              {paragraphs[3]}
            </p>

            {}
            <blockquote className="my-14 border-l-2 border-[var(--chart-1)] pl-8">
              <p className="font-default text-[28px] leading-[1.25] italic text-foreground md:text-[36px]">
                "Cada paciente es único; nuestro compromiso es ofrecer soluciones a medida, no fórmulas mágicas."
              </p>
            </blockquote>

            {}
            <p data-index={4} className="mb-10 text-[18px] leading-[1.7] text-muted-foreground font-default">
              {paragraphs[4]}
            </p>

            {}
            <p data-index={5} className="mb-12 text-[18px] leading-[1.7] text-muted-foreground font-default">
              {paragraphs[5]}
            </p>

            {}
            
          </div>
        </div>
      </div>
    </section>;
}